import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import type { Eye } from 'lucide-react';

import { IconBadge } from '@modules/_shared/shared/components/IconBadge';

export const MetricTile = ({
  icon: IconComponent,
  label,
  value,
  loading,
}: {
  icon: typeof Eye;
  label: string;
  value: number | string;
  loading: boolean;
}) => (
  <Stack direction="row" spacing={1.25} sx={{ flex: 1, alignItems: 'center' }}>
    <IconBadge
      icon={IconComponent}
      color="primary.main"
      backgroundColor="primary.lighter"
    />
    <Box sx={{ minWidth: 0 }}>
      <Box sx={{ height: 24, display: 'flex', alignItems: 'center' }}>
        {loading ? (
          <CircularProgress size={16} />
        ) : (
          <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
            {value}
          </Typography>
        )}
      </Box>
      <Typography
        component="div"
        variant="caption"
        sx={{ fontWeight: 500, color: 'text.secondary', lineHeight: 1.3 }}
      >
        {label}
      </Typography>
    </Box>
  </Stack>
);
